<template>
  <div class="sub-container">
    <!--  -->
    <div class="no-goods">
      <div class="img">
        <i class="icon icon-no-gamble"></i>
      </div>
      <div class="tips">
        <span>即将开放，敬请期待！</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { getDict, axios, getPageLevelMixin } from '../../common'
  import { mapState, mapGetters } from 'vuex'
  import alert from '../../components/alert'

  export default {
    mixins:[],
    props:{
    },
    data(){
      return {
      }
    },
    computed:{
    },
    watch:{
    },
    methods: {
      getDict,
    },
    components: {
      alert,
    },
    mounted(){
      
    },
    created(){
    }
  }
</script>

<style lang="scss" scoped>
  .sub-container{
    width: 100%;
    height: 100%;
    padding: 0 0.4rem;
    display: flex;
    flex-direction: column;
    // justify-content: space-between;
    
    .no-goods{
      text-align: center;
      display: flex;
      flex-direction: column;
      height: 90%;
      justify-content: center;
      .img{
        .icon{
          margin: 0;
        }
      }
      .tips{
        margin-top: 0.1rem;
        font-size: 0.25rem;
      }
    }
  }


</style>
